import * as React from 'react'
const EditIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M13.24 2.82a2.78 2.78 0 014.07 3.79l-.13.14-9.61 9.61a2 2 0 01-.72.46l-.16.05L2.63 18a.5.5 0 01-.63-.55v-.08l1.1-4.06a2.13 2.13 0 01.4-.76l.12-.13zm-.86 2.27l-8 8a.87.87 0 00-.22.32v.12l-.88 3.22 3.21-.88a.87.87 0 00.24-.1l.11-.07.1-.09 8-8zm4.09-1.57a1.79 1.79 0 00-2.4-.11l-.07.11-.86.87 2.52 2.52.86-.86a1.79 1.79 0 00.11-2.41z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default EditIcon